import React, { useEffect } from 'react';
import '../styles/Disclaimer.css';

const Disclaimer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/919024000691?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/919024000691?text=${encodedMessage}`;

  return (
    <section className="disclaimer-page">
      <div className="disclaimer-header">
        <h1 className="disclaimer-title"><span className='highlight'>Disclaimer - </span>Reddy Anna</h1>
        <p className="disclaimer-update-date">Last Updated: 16/03/2026</p>
      </div>

      <div className="disclaimer-content">
        <p>
          Welcome to the Reddy Anna Book Disclaimer Page. By accessing
          and using our platform, you acknowledge and agree to the terms
          outlined in this disclaimer. Please read this document carefully to
          understand the limitations and responsibilities associated with the
          use of our services.
        </p>

        <p><strong>1. Information Accuracy: </strong>
          While we strive to ensure the accuracy of information presented on
          Reddy Anna, we do not guarantee the completeness, accuracy, or
          reliability of any content. Users are encouraged to verify
          information independently.
        </p>

        <p>
         <strong>2. Gambling Risks: </strong> Participation in online gambling involves inherent risks. Reddy Anna
          Book provides entertainment services, and users are solely
          responsible for the risks associated with betting and gaming
          activities. We do not accept liability for any financial losses or
          consequences arising from gambling.
        </p>

        <p>
          <strong>3. Platform Availability: </strong>
          We make reasonable efforts to maintain the availability and
          functionality of Reddy Anna. However, we do not guarantee
          uninterrupted access, and we reserve the right to temporarily or
          permanently suspend services without prior notice.
        </p>

        <p>
          <strong>4. Third-Party Content: </strong>
          Reddy Anna may contain links to third-party websites or content. We
          do not endorse or take responsibility for the content, accuracy, or
          security of external sites. Users accessing third-party links do so
          at their own risk.
        </p>

        <p>
          <strong>5. Security Measures: </strong>
          We employ security measures to protect user information. However, the
          internet is not entirely secure, and we cannot guarantee the absolute
          security of data transmitted through our platform. Users are
          encouraged to take necessary precautions.
        </p>

        <p>
          <strong>6. Changes to Disclaimer: </strong>
          Reddy Anna Book may update this disclaimer periodically.
          Users are responsible for reviewing the disclaimer regularly.
          Continued use of our platform after changes implies acceptance of the
          updated disclaimer.
        </p>

        <p>
        <strong>7. Legal Compliance: </strong>
          Users are responsible for complying with all local laws and
          regulations related to online gambling. Reddy Anna Book does
          not warrant that its services comply with the laws of all
          jurisdictions.
        </p>
        <p>
          <strong>8. Contact Information: </strong>
          If you have any questions or concerns about this disclaimer, please
          contact us at{' '}
          <a href={ContactLink}>+91 6666947913</a>.
        </p>

        <p>
        By using Reddy Anna Book, you acknowledge and agree to the terms outlined in this disclaimer. We appreciate your understanding and cooperation.
        </p>

        <p style={{color: "#C62E2E"}}>
        Thank you for choosing Reddy Anna Book. We are dedicated to providing a secure and enjoyable gaming experience for our users.
        </p>
      </div>

      <div className="disclaimer-btn">
      <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us @ 6666856666
          </a>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            WhatsApp Us @ 6666066663
          </a>
      </div>
    </section>
  );
};

export default Disclaimer;
